import { render, staticRenderFns } from "./orgRoleForm.vue?vue&type=template&id=12bd6930&scoped=true&"
import script from "./orgRoleForm.vue?vue&type=script&lang=js&"
export * from "./orgRoleForm.vue?vue&type=script&lang=js&"
import style0 from "./orgRoleForm.vue?vue&type=style&index=0&id=12bd6930&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bd6930",
  null
  
)

export default component.exports